var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"lazy-render":false,"close-icon":"close","close-on-click-overlay":false},model:{value:(_vm.showTips),callback:function ($$v) {_vm.showTips=$$v},expression:"showTips"}},[_c('div',{ref:"canvasWrapper",staticClass:"codeQr"}),_c('div',{staticClass:"codeTxt"},[_vm._v("请使用微信扫码打开")])])
}
var staticRenderFns = []

export { render, staticRenderFns }